/* eslint-disable @typescript-eslint/no-explicit-any */
import axiosInstance from "@/lib/axios";
import { useQuery } from "@tanstack/react-query";
import { ROLE_CACHE_GC_MS, ROLE_CACHE_STALE_MS } from "@/lib/queryClient";
import { useEffect } from "react";
import { rolePipeline } from "@/config/endpoints";

// Fixed: callback type, invalid parenthesis, improved typing and lints

export default function useRolesPipeline(
  callBack?: (data: any) => void,
  filters: Record<string, any> = {}
) {
  const query = useQuery({
    queryKey: ["roles-pipeline", filters],
    queryFn: async () => {
      // ========================================================================
      // STATIC DATA MODE - Return dummy data
      // TODO: Remove this import and uncomment API integration before pushing
      // ========================================================================
      // return Promise.resolve(dummyRolesPipeline);
      // ========================================================================
      // API INTEGRATION - Uncomment before pushing to production
      // ========================================================================
      const res = await axiosInstance.get(rolePipeline, { params: filters });
      return res.data.rolePipeline;
    },
    // Role shape changes rarely and every writer that changes it already
    // busts this key (role save/delete in FormRoleContext, invalidateUserCaches,
    // invalidateBranchCaches, invalidateLeadAssignment,
    // invalidatePipelineDependentCaches, USER_ACCESS_REFRESH). Long stale /
    // gc windows so remounts across pages don't refetch it — it was 175k
    // GETs a day under the 3-min default plus the socket bundle's prefix bust.
    staleTime: ROLE_CACHE_STALE_MS,
    gcTime: ROLE_CACHE_GC_MS,
  });

  useEffect(() => {
    if (query.data && callBack) {
      callBack(query.data);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query.data]);

  const rolesSelects =
    query.data?.map((val: any) => ({
      value: String(val.id),
      name: val.name,
    })) ?? [];

  return {
    rolesPipeline: query.data,
    length: query.data ? query.data.length : 0,
    rolesSelects,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}
